const technicalFaultPlayerSelectActions = [
  {
    actions: [
      { action: "sendEvent", value: "edit", type: "main" },
      { action: "copyEvent", value: "offensive-foul-technical-fault", type: "to" },
      {
        action: "setPossession",
        value: { currentEntity: false },
        type: "main",
      },
      {
        action: "nextState",
        value: "offensive-foul-first-defender",
        type: "primary",
      },
    ],
    conditions: [
      {
        item: "options",
        value: "offensiveFoul",
        event: "main",
        operator: "is",
      },
    ],
  },
  {
    actions: [
      { action: "sendEvent", value: "edit", type: "main" },
      {
        action: "setPossession",
        value: { currentEntity: false },
        type: "main",
      },
      { action: "nextState", value: null, type: "primary" },
      { action: "processInserts", value: "all", type: "inserts" },
    ],
    conditions: [
      {
        item: "options",
        value: "offensiveFoul",
        event: "main",
        operator: "not",
      },
    ],
  }
];

export const TechnicalFaultPlayer = {
  name: "technical-fault-player",
  component: "MainPanel",
  layout: "main-panel large align-center",
  mode: "visible",
  text: "technicalFault.select-player",
  showOn: [{ state: "primary", value: "technical-fault-player", operator: "is" }],
  allowFlag: true,
  allowCancel: true,
  allowCancelEvent: "main",
  showDetails: { events: ["main"] },
  allowBack: {
    state: "primary",
    value: "technical-fault-type",
    event: "main",
  },
  children: [
    {
      name: "technical-fault-player-select",
      component: "PlayerSelect",
      layout: "player-select",
      mode: "visible",
      startEvent: false,
      startPlay: false,
      showOn: [true],
      options: {
        currentEntity: true,
        showBench: false,
        showCoach: false,
        immutableDateTime: true,
      },
      actionGroups: technicalFaultPlayerSelectActions,
    },
    {
      name: "confirm-later-technical-fault-player",
      component: "TypeButton",
      layout: "match-button",
      mode: "enable",
      text: "confirmLater",
      showOn: [true],
      options: {
        immutableDateTime: true,
      },
      actionGroups: [
        {
          actions: [
            { action: "saveData", type: "flagged", value: true },
          ],
        },
        ...technicalFaultPlayerSelectActions,
      ],
      startEvent: false,
      startPlay: false,
    },
  ],
};
